module.exports = __webpack_public_path__ + "img/following-step05.1beb0206.svg";